export const autocompleteDropdownNoOptionsStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
		p: 2,
		gap: 2
	},

	searchIcon: {
		color: 'text.secondary',
		width: '100px',
		height: '100px'
	},

	description: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		px: 2
	},

	text: {
		display: 'inline-block',
		color: 'text.secondary',
		'*': {
			display: 'inline-block',
			verticalAlign: 'top'
		}
	},

	query: {
		maxWidth: 150,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontWeight: 700
	}
};
